export default "__VITE_ASSET__CxwD6zGQ__"